import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_grievances_and_disputes_resolved_in_line_w_legal_reqs'

export const dataPointDefinition = {
  retracedId: 'are_grievances_and_disputes_resolved_in_line_w_legal_reqs',
  name: 'Are grievances and disputes resolved in line with legal requirements?',
  description:
    "Consult applicable legal requirements before answering this question. This question refers to both HOW the process of handling the grievance or dispute has been carried out and the CONTENT of the final settlement that needs to be in line with legal requirements. Settlements cannot be below the legal standards.\r\r\n\r\r\nIf there are no applicable legal requirements, answer No applicable legal requirements. \r\r\n\r\r\nGrievances are complaints raised by one or more workers (or a trade union) against the facility regarding employment relations, working conditions, or the employer's policies or practices that concern existing right(s) (e.g. under the law, collective agreement, employment contract, work rules or internal regulations). \r\r\n\r\r\nA collective dispute is a disagreement between a group of workers, usually but not necessarily represented by a trade union, and an employer or group of employers over existing rights or future interests.\r\r\n\r\r\nAn individual dispute is a disagreement between a single worker and the employer usually over existing rights, and can also include situations in which a number of workers disagree with their employer over the same issue, but where each worker acts as an individual.\r\r\n\r\r\nIf there were no grievances or disputes, answer Yes.",
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no-nalr',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
    },
    {
      name: 'No applicable legal requirements',
      key: 'NO_APPLICABLE_LEGAL_REQS',
      slcpIndex: 3,
      slcpOptionName: 'yes-no-nalr',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NO_APPLICABLE_LEGAL_REQS'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-gri-8',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 13150,
  sectionId: '2.2.10',
  impactArea: 'Social Dialogue, Grievance Mechanisms and Disputes',
  impactAreaId: 'COMPLAINT_AND_GRIEVANCE_SYSTEMS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
